import { Controller } from "stimulus"

export default class extends Controller {

    toggleLabel(event) {
        if (this.checkValidity()) {
            if (event.target.value.length == 0) {
                event.target.previousSibling.previousSibling.classList.add("opacity-0");
                event.target.classList.remove("pt-4");
            } else {
                event.target.previousSibling.previousSibling.classList.remove("opacity-0");
                event.target.classList.add("pt-4");
            }
            this.calculate();
        }
    }

    calculate() {
        var salesPageView = Number(document.getElementById("sales_view").value) || 0;
        var salesConversionRate = Number(document.getElementById("sales_conversion_rate").value) || 0;
        var salesPurchaseConversionRate = Number(document.getElementById("sales_purchase_conversion_rate").value) || 0;
        var salesPurchaseUnitPrice = Number(document.getElementById("sales_purchase_unit_price").value) || 0;
        var orderConversionRate = Number(document.getElementById("order_conversion_rate").value) || 0;
        var orderUnitPrice = Number(document.getElementById("order_unit_price").value) || 0;
        var otoConversionRate = Number(document.getElementById("oto_conversion_rate").value) || 0;
        var otoUnitPrice = Number(document.getElementById("oto_unit_price").value) || 0;
        var salesPageConversion, salesPurchaseConversion, salesPurchaseSubTotal, orderConversion, orderSubTotal, otoConversion, otoSubTotal, total;
        var format = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
        });
        salesPageConversion = Math.round(salesPageView * salesConversionRate / 100);
        salesPurchaseConversion = Math.round(salesPageConversion * salesPurchaseConversionRate / 100);
        salesPurchaseSubTotal = Number((salesPurchaseConversion * salesPurchaseUnitPrice).toFixed(2));
        orderConversion = Math.round(salesPurchaseConversion * orderConversionRate / 100);
        orderSubTotal = Number((orderConversion * orderUnitPrice).toFixed(2));
        otoConversion = Math.round(otoConversionRate * salesPurchaseConversion / 100);
        otoSubTotal = Number((otoConversion * otoUnitPrice).toFixed(2));
        total = salesPurchaseSubTotal + orderSubTotal + otoSubTotal;
        document.getElementById("sales_conversion").value = salesPageConversion;
        document.getElementById("sales_purchase_conversion").value = salesPurchaseConversion;
        document.getElementById("sales_purchase_sub_total").value = salesPurchaseSubTotal;
        document.getElementById("order_conversion").value = orderConversion;
        document.getElementById("order_sub_total").value = orderSubTotal;
        document.getElementById("oto_conversion").value = otoConversion;
        document.getElementById("oto_sub_total").value = otoSubTotal;
        document.getElementById("total").innerText = `${format.format(total)}`;
    }

    reset() {
        document.getElementById("sales_view").value = null;
        document.getElementById("sales_conversion_rate").value = null;
        document.getElementById("sales_purchase_conversion_rate").value = null;
        document.getElementById("sales_purchase_unit_price").value = null;
        document.getElementById("order_conversion_rate").value = null;
        document.getElementById("order_unit_price").value = null;
        document.getElementById("oto_conversion_rate").value = null;
        document.getElementById("oto_unit_price").value = null;
        document.getElementById("sales_view").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("sales_view").classList.remove("pt-4");
        document.getElementById("sales_conversion_rate").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("sales_conversion_rate").classList.remove("pt-4");
        document.getElementById("sales_purchase_conversion_rate").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("sales_purchase_conversion_rate").classList.remove("pt-4");
        document.getElementById("sales_purchase_unit_price").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("sales_purchase_unit_price").classList.remove("pt-4");
        document.getElementById("order_conversion_rate").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("order_conversion_rate").classList.remove("pt-4");
        document.getElementById("order_unit_price").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("order_unit_price").classList.remove("pt-4");
        document.getElementById("oto_conversion_rate").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("oto_conversion_rate").classList.remove("pt-4");
        document.getElementById("oto_unit_price").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("oto_unit_price").classList.remove("pt-4");
        document.getElementById("sales_conversion").value = 0;
        document.getElementById("sales_purchase_conversion").value = 0;
        document.getElementById("sales_purchase_sub_total").value = 0;
        document.getElementById("order_conversion").value = 0;
        document.getElementById("order_sub_total").value = 0;
        document.getElementById("oto_conversion").value = 0;
        document.getElementById("oto_sub_total").value = 0;
        document.getElementById("total").innerText = `$0.00`;
    }

    checkValidity() {
        if (!(document.getElementById("sales_view").checkValidity() && document.getElementById("sales_conversion_rate").checkValidity())) {
            document.getElementById("sales_purchase_invalid").classList.add("hidden");
            document.getElementById("sales_invalid").classList.remove("hidden");
            document.getElementById("order_invalid").classList.add("hidden");
            document.getElementById("oto_invalid").classList.add("hidden");
            return false;
        }
        if (!(document.getElementById("sales_purchase_unit_price").checkValidity() && document.getElementById("sales_purchase_conversion_rate").checkValidity())) {
            document.getElementById("sales_purchase_invalid").classList.remove("hidden");
            document.getElementById("sales_invalid").classList.add("hidden");
            document.getElementById("order_invalid").classList.add("hidden");
            document.getElementById("oto_invalid").classList.add("hidden");
            return false;
        }
        if (!(document.getElementById("order_unit_price").checkValidity() && document.getElementById("order_conversion_rate").checkValidity())) {
            document.getElementById("sales_purchase_invalid").classList.add("hidden");
            document.getElementById("sales_invalid").classList.add("hidden");
            document.getElementById("order_invalid").classList.remove("hidden");
            document.getElementById("oto_invalid").classList.add("hidden");
            return false;
        }
        if (!(document.getElementById("oto_unit_price").checkValidity() && document.getElementById("oto_conversion_rate").checkValidity())) {
            document.getElementById("sales_purchase_invalid").classList.add("hidden");
            document.getElementById("sales_invalid").classList.add("hidden");
            document.getElementById("order_invalid").classList.add("hidden");
            document.getElementById("oto_invalid").classList.remove("hidden");
            return false;
        }
        document.getElementById("sales_purchase_invalid").classList.add("hidden");
        document.getElementById("sales_invalid").classList.add("hidden");
        document.getElementById("order_invalid").classList.add("hidden");
        document.getElementById("oto_invalid").classList.add("hidden");
        return true;
    }
}